"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("./consts");
/* UNWATCH */
function unwatch(object) {
    return object && (object[consts_1.$STOP] || object);
}
/* EXPORT */
exports.default = unwatch;
